<template>
	<Spin :spinning="isLoading">
		<div v-if="series.length > 0" :style="{ height: heightRef + 'px'}">
			<VueApexCharts width="100%" height="100%" :type="chartType" :options="chartOptions" :series="series" />
		</div>
		<CenterLayout v-else width="100%" :height="heightRef + 'px'">
			<Empty :image="simpleImage">
				<template #description v-if="$slots.description">
					<slot name="description"></slot>
				</template>
			</Empty>
		</CenterLayout>
	</Spin>
</template>

<script>
import { toRef, computed } from 'vue';
import { Spin, Empty } from 'ant-design-vue';

import VueApexCharts from 'vue3-apexcharts';

import { buildIsolatedPointAnnotations } from '@/utils/chartsUtils';
import CenterLayout from '@/components/common/CenterLayout.vue';


export default {
	components: {
		Spin, Empty, CenterLayout, VueApexCharts,
	},
	props: {
		isLoading: {
			type: Boolean,
		},
		series: {
			type: Array,
		},
		options: {
			type: Object,
		},
		height: {
			type: Number,
			default: 400,
		},
		chartType: {
			type: String,
			default: 'line',
		},
	},
	setup(props) {
		const heightRef = toRef(props, 'height');
		// Одиночные точки (соседи с обеих сторон null) линией не рисуются и без
		// маркеров невидимы. Маркеры на всех точках тормозят график, поэтому
		// показываем такие точки точечными аннотациями. Актуально только для line.
		const chartOptions = computed(() => {
			const options = props.options || {};
			if (props.chartType !== 'line') {
				return options;
			}
			const isolatedPointMarkers = buildIsolatedPointAnnotations(
				props.series || [],
				options.colors || [],
			);
			if (isolatedPointMarkers.length === 0) {
				return options;
			}
			const existingAnnotations = options.annotations || {};
			const existingPoints = existingAnnotations.points || [];
			return {
				...options,
				annotations: {
					...existingAnnotations,
					points: [...existingPoints, ...isolatedPointMarkers],
				},
			};
		});
		return {
			heightRef,
			chartOptions,
			simpleImage: Empty.PRESENTED_IMAGE_SIMPLE,
		};
	},
}
</script>
